<template>
  <div>
    <v-container class="d-flex justify-space-between align-center py-2">
      <div style="border: solid 1px #999; padding: 10px 20px; width: 100%;">
        請依照下列步驟進行商品上傳<br>
        1. 上傳圖片<br>
        2. 下載Demo檔案<br>
        3. 依照Demo檔案內容填寫商品資訊<br>
        4. 上傳商品檔案<br>
        注意事項：為避免資料量過大導致匯入失敗，建議每次匯入 不超過 300 筆（約 Excel 300 行）。<br>
        若超過，請分批匯入，以避免處理時間過長造成匯入中斷。
      </div>
    </v-container>
    <v-container class="d-flex flex-column justify-space-between align-center py-2">
      <label for="product-photo-upload" class="custom-file-upload d-flex align-center justify-flex-start">
        <input
          id="product-photo-upload"
          type="file"
          hidden
          multiple
          @change="inputPhoto"
        />
        <v-btn
          color="primary"
          :loading="photoLoading"
          class="mx-2 my-2"
          style="pointer-events: none;"
        >上傳圖片</v-btn>
      </label>
      <v-btn
        color="primary"
        class="mx-2 my-2"
        @click.native="getProductImportSample"
      >
        <span>下載Demo檔案</span>
      </v-btn>
      <label for="product-file-upload" class="custom-file-upload d-flex align-center justify-flex-start">
        <input
          id="product-file-upload"
          type="file"
          hidden
          @change="inputFile"
        />
        <v-btn
          color="primary"
          :loading="fileLoading"
          class="mx-2 my-2"
          style="pointer-events: none;"
        >上傳商品檔案</v-btn>
      </label>
    </v-container>
    <v-container class="px-5">
      <v-sheet rounded class="elevation-1" v-if="imageContents.length !== 0">
        <v-container>
          <v-row class="bg-primary white--text">
            <v-col v-for="(header, index) in imageHeader" :key="index" :cols="header.cols" :class="header.class">
              <span>{{ header.text }}</span>
            </v-col>
          </v-row>
          <v-row v-for="(row, index) in imageContents" class="" :key="index">
            <v-col v-for="(content, index) in row" :key="index" :cols="content.cols" :class="content.class">
              <span>{{ content.text }}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-container>

    <!-- 匯入錯誤紀錄 -->
    <v-container class="px-5">
      <v-sheet rounded class="elevation-1" v-if="importErrorLogs.length > 0">
        <v-container>
          <v-row class="bg-error white--text">
            <v-col cols="1" class="text-center">
              <span>Excel行數</span>
            </v-col>
            <v-col cols="3" class="text-center">
              <span>商品</span>
            </v-col>
            <v-col cols="8" class="text-center">
              <span>錯誤訊息</span>
            </v-col>
          </v-row>
          <v-row
            v-for="(row, index) in importErrorLogs"
            :key="index"
          >
            <v-col cols="1" class="text-center">
              <span>第{{ row.rowIndex }}行</span>
            </v-col>
            <v-col cols="4" class="text-center">
              <div v-if="row.payload" class="text-truncate">
                {{ row.payload.product_name }}
              </div>
            </v-col>
            <v-col cols="7" class="text-center">
              <span v-if="row.payload">
                <!-- {{ row.payload.errors.join(', ') }} -->
                  <div v-for="(error, index) in row.payload.errors" :key="`error-${row.rowIndex}-${index}`">
                    <span>❌ {{ error }}</span>
                  </div>
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-container>

    <!-- 匯入一般紀錄 -->
    <v-container class="px-5">
      <v-sheet rounded class="elevation-1" v-if="importNormalLogs.length > 0">
        <v-container>
          <v-row class="bg-primary white--text">
            <v-col cols="8" class="text-center">
              <span>匯入紀錄</span>
            </v-col>
            <v-col cols="4" class="text-center">
              <span>時間</span>
            </v-col>
          </v-row>
          <v-row
            v-for="(row, index) in importNormalLogs"
            :key="index"
          >
            <v-col cols="8" class="text-center">
              <span>{{ row.message }}</span>
            </v-col>
            <v-col cols="4" class="text-center">
              <span>{{ row.time }}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'

export default {
  data: () => ({
    photoLoading: false,
    fileLoading: false,
    imageContents: [],
    importLogs: [],
  }),
  computed: {
    importNormalLogs() {
      return this.importLogs.filter((log) => !log.isErrorLog)
    },
    importErrorLogs() {
      return this.importLogs.filter((log) => log.isErrorLog)
    },
    providerId () {
      return this.$store.getters['member/providerId']
    },
    imageHeader () {
      return [
        {text: '圖片檔案名稱', class: "text-center"},
        {text: '上傳狀態', cols: 4, class: "text-center"},
      ]
    },
  },
  methods: {
    async inputPhoto (file) {
      console.log('inputPhoto:', file, file.target.files)
      if (!file) return
      if (file.length === 0) return
      const fileOverSize = (size) => {
        const Number1MBSIZE = 100 * 1024 * 1024
        return size > Number1MBSIZE
      }
      const acceptType = ['image/png', 'image/jpeg', 'image/jpg']
      const fileList = [...file.target.files].filter((fileItem) => {
        return acceptType.includes(fileItem.type) && !fileOverSize(fileItem.size)
      })
      try {
        this.photoLoading = true
        this.imageContents = []
        for (const file of fileList) {
          const formData = new FormData()
          formData.append('file', file)
          const res = await this.$api.collection.providerApi.putProductImportPhoto(this.providerId, formData)
          this.imageContents.push([
            {text: res.result[0].file, class: "text-center"},
            {text: res.result[0].status, cols: 4},
          ])
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.photoLoading = false
      }
    },
    async inputFile(file) {
      console.log('inputFile:', file)
      if (!file) return
      if (file.length === 0) return
      const fileOverSize = (size) => {
        const Number1MBSIZE = 100 * 1024 * 1024
        return size > Number1MBSIZE
      }
      const acceptType = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
      if(!acceptType.includes(file.target.files[0].type)){
        this.$snotify.warning('檔案類型不支援')
        return
      }
      if (fileOverSize(file.target.files[0].size)) {
        this.$snotify.warning('上傳檔案不得大於100MB')
        return
      }
      this.importLogs = []
      try {
        this.fileLoading = true
        let formData = new FormData()
        formData.append('file', file.target.files[0])
        const result = await this.$api.collection.providerApi.putProductImportFile(this.providerId, formData)
        this.importLogs = result.logs
        console.warn('this.importErrorLogs', this.importErrorLogs)
        console.warn('this.importNormalLogs', this.importNormalLogs)

        if (result.hasFatalError) {
          this.$snotify.error('發生意外的錯誤，請檢查錯誤訊息', '匯入商品Excel失敗')
          return
        }
        if (result.errorCounts > 0) {
          this.$snotify.error(`${result.errorCounts}筆資料有錯誤，已撤銷所有資料寫入，請檢查錯誤訊息`, '匯入商品Excel失敗')
        } else {
          this.$snotify.success('商品已全數匯入成功，請至「商品管理」頁面查看', '匯入商品Excel成功')
        }
      } catch (err) {
        console.error(err)
        this.$snotify.error('發生意外的錯誤，請檢查錯誤訊息', '匯入商品Excel失敗')
      } finally {
        this.fileLoading = false
        $('#product-file-upload').val('')
      }
    },
    async getProductImportSample () {
      const response = await this.$api.collection.providerApi.getProductImportSample()
      saveAs(response.url, response.name)
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>